import { VehicleUseage } from '@/modules/Vehicle/interfaces/vehicle'

export const vehicleUseageOptions = [
  {
    label: 'Pleasure',
    value: VehicleUseage.PLEASURE
  },
  {
    label: 'Commute',
    value: VehicleUseage.COMMUTE
  }
]

export const showUseageLabel = (val: VehicleUseage |string | null) => {
  if (!val) {
    return null
  }
  const useageObject = vehicleUseageOptions.find((option) => option.value === val)
  return useageObject && useageObject.label ? useageObject.label : ''
}
